import { ThemeConfig } from 'antd';

const theme = {
  YellowPrimary: '#EDE04A',        // rgb(237,224,74) — redesign primary yellow
  YellowPrimaryHover: '#E6D93C',   // rgb(230,217,60) — redesign primary hover
  TunaPrimary: '#39393C',           // rgb(57,57,60) — redesign foreground
  darkBrown: '#312011',
  SemiBlue: '#2CCCFF',
  LightBlue: '#E2F8FF',
  DarkBlue: '#6116FF',
  LightPurple: '#EBE2FF',
  GrayShade1: '#F5F5F3',           // rgb(245,245,243) — redesign muted bg
  GrayShade2: '#F5F5F3',           // same as GrayShade1 for consistency
  GrayShade3: '#F0F0EE',           // slightly darker muted
  GrayShade4: '#E8E6E3',           // rgb(232,230,227) — redesign border
  GrayShade5: '#737B8C',           // rgb(115,123,140) — redesign muted text
  White: '#FFFFFF', //without  name in figma
  Blue: '#1677FF',
  BlueShade1: '#EEF5FF',
  Green: '#2BB45D',
  GreenShade1: '#CCF0D9',
  Black: '#000000', //without  name in figma
  Orange: '#F39F54',
  OrangeShade1: '#FDEEE0',
  Red: '#DC3545',
  RedShade1: '#FCDCDB',
  ValentineRed: '#F05652',
  YellowDark: '#7C7329',
  MuddyGreen: '#6DA544', //without  name in figma
  DarkRed: '#D80027', //without  name in figma,
  ColorsBrown: '#A2845E',
  Violet: '#A360E2',
  HavelockBlue: '#5E90CC',
  Mint: '#00C7BE',
  pur: '#00C7BE',
  Magenta: '#D732A8',
  Purple: '#AF52DE',
  Teal: '#30B0C7',
  DeepBlue: '#5454FB',
  VioletShade1: '#F0E5FA',
  OceanBlueLight: '#E2F8FF',
  YellowLight: '#FFFDE8',
  DeepLight: '#E8E9FF',
  HavelockBlueShade1: '#F4F9FF',
  MagentaShade1: '#FFEBF9', //without  name in figma
  PurpleLight: '#FDF7FF', //without  name in figma
  TealShade1: '#EBFFEE', //without  name in figma
  WarningSecondary: '#FFF1C2', //without  name in figma
  MintLight: '#E4FFFE',
};
// Added custom to all colors, call them this way: custom...
export const THEME_VARIABLE: ThemeConfig['token'] & Record<string, string> = {
  customYellowPrimary: theme.YellowPrimary,
  customTunaPrimary: theme.TunaPrimary,
  customDarkBrown: theme.darkBrown,
  customSemiBlue: theme.SemiBlue,
  customLightBlue: theme.LightBlue,
  customDarkBlue: theme.DarkBlue,
  customLightPurple: theme.LightPurple,
  customGrayShade1: theme.GrayShade1,
  customGrayShade2: theme.GrayShade2,
  customGrayShade3: theme.GrayShade3,
  customGrayShade4: theme.GrayShade4,
  customGrayShade5: theme.GrayShade5,
  customWhite: theme.White,
  customBlue: theme.Blue,
  customBlueShade1: theme.BlueShade1,
  customGreen: theme.Green,
  customGreenShade1: theme.GreenShade1,
  customBlack: theme.Black,
  customOrange: theme.Orange,
  customOrangeShade1: theme.OrangeShade1,
  customRed: theme.Red,
  customRedShade1: theme.RedShade1,
  customValentineRed: theme.ValentineRed,
  customYellowDark: theme.YellowDark,
  customMuddyGreen: theme.MuddyGreen,
  customDarkRed: theme.DarkRed,
  customColorsBrown: theme.ColorsBrown,
  customViolet: theme.Violet,
  customHavelockBlue: theme.HavelockBlue,
  customMint: theme.Mint,
  customMagenta: theme.Magenta,
  customPurple: theme.Purple,
  customTeal: theme.Teal,
  customDeepBlue: theme.DeepBlue,
  customVioletShade1: theme.VioletShade1,
  customOceanBlueLight: theme.OceanBlueLight,
  customYellowLight: theme.YellowLight,
  customDeepLight: theme.DeepLight,
  customHavelockBlueShade1: theme.HavelockBlueShade1,
  customMagentaShade1: theme.MagentaShade1,
  customPurpleLight: theme.PurpleLight,
  customTealShade1: theme.TealShade1,
  customWarningSecondary: theme.WarningSecondary,
  customMintLight: theme.MintLight,
  colorPrimary: theme.YellowPrimary,
  colorTextBase: theme.TunaPrimary,
  fontSizeBase: '16px',

  //TABLE of DEFAULT THEME :
  // Colors
  // colorPrimary: '#1890ff', // Primary color
  colorPrimaryHover: theme.YellowPrimaryHover, // Primary color on hover
  colorPrimaryActive: theme.YellowPrimaryHover, // Primary color on active state
  colorPrimaryDisabled: '#d6e4ff', // Disabled primary color
  colorSuccess: '#52c41a', // Success color
  colorWarning: '#faad14', // Warning color
  colorError: '#f5222d', // Error color
  // colorTextBase: '#000000d9', // Base text color
  colorTextSecondary: '#00000073', // Secondary text color
  colorTextDisabled: '#00000040', // Disabled text color
  colorBorderBase: '#E8E6E3', // rgb(232,230,227) — redesign border
  colorBorderSplit: '#F5F5F3', // rgb(245,245,243) — redesign muted
  colorBackgroundBase: '#ffffff', // Base background color
  colorBackgroundContainer: '#F5F5F3', // rgb(245,245,243) — redesign muted bg

  // Typography
  // fontSizeBase: '14px', // Base font size
  fontSizeLg: '16px', // Large font size
  fontSizeSm: '12px', // Small font size
  // lineHeightBase: 1.5, // Base line height
  // lineHeightLg: 1.6, // Large line height
  // lineHeightSm: 1.4, // Small line height
  // fontWeightBase: 400, // Base font weight
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif', // Font family

  // Padding and Margins
  paddingBase: '16px', // Base padding
  paddingLg: '24px', // Large padding
  paddingSm: '12px', // Small padding
  marginBase: '16px', // Base margin
  marginLg: '24px', // Large margin
  marginSm: '12px', // Small margin

  // Borders — redesign uses rounded-lg (8px) to rounded-2xl (16px)
  borderRadiusBase: '10px', // Base border radius (inputs, selects)
  borderRadiusSm: '8px', // Small border radius (tags, badges)
  borderWidthBase: '1px', // Base border width
  borderColorBase: theme.GrayShade4, // rgb(232,230,227) — redesign border
  borderStyleBase: 'solid', // Base border style

  // Buttons — redesign uses h-9 (36px) with rounded-lg (8px)
  buttonPaddingHorizontal: '20px', // Button horizontal padding
  buttonPaddingVertical: '8px', // Button vertical padding
  buttonBorderRadius: '8px', // Button border radius (rounded-lg)
  buttonHeightBase: '36px', // Base button height (h-9)
  buttonHeightLg: '44px', // Large button height (h-11)
  buttonHeightSm: '24px', // Small button height

  // Inputs — redesign uses rounded-xl (10px) inputs
  inputPaddingHorizontal: '14px', // Input horizontal padding
  inputPaddingVertical: '10px', // Input vertical padding
  inputBorderRadius: '10px', // Input border radius (rounded-xl)
  inputHeightBase: '40px', // Base input height
  inputHeightLg: '44px', // Large input height
  inputHeightSm: '32px', // Small input height

  // Forms
  formItemMarginBottom: '20px', // Margin bottom for form items
  labelColor: '#39393C', // rgb(57,57,60) — redesign foreground
  labelFontSize: '13px', // Label font size

  // Tables
  tablePadding: '16px', // Table padding
  tableBorderColor: '#F5F5F3', // rgb(245,245,243) — redesign subtle border
  tableHeaderBackground: 'transparent', // No bg — redesign header is transparent
  tableHeaderColor: '#737B8C', // rgb(115,123,140) — redesign muted text

  // Modals — redesign uses rounded-2xl (16px)
  modalHeaderPadding: '24px', // Modal header padding
  modalBodyPadding: '24px', // Modal body padding
  modalFooterPadding: '16px', // Modal footer padding
  modalBorderRadius: '16px', // Modal border radius (rounded-2xl)
  modalHeaderColor: '#39393C', // rgb(57,57,60) — redesign foreground

  // Shadows — redesign uses softer shadows
  boxShadowBase: '0 8px 32px rgba(0, 0, 0, 0.10)', // Base box shadow
  boxShadowSecondary: '0 4px 16px rgba(0, 0, 0, 0.06)', // Secondary box shadow

  // Links — redesign uses foreground color for links
  linkColor: '#39393C', // rgb(57,57,60) — redesign foreground
  linkHoverColor: '#39393C', // Same as base
  linkActiveColor: '#39393C', // Same as base
  colorWhite: '#FFF',
  colorBlack: '#000',
};
